<template>
  <CRow class="mt-4">
    <CCol class="col-12">
      <CRow class="align-items-center background-indicadores" style="height: 60px">
        <CCol sm="4" class="pl-3 d-flex">
          <p class="d-flex align-self-center mb-0">
            <CIcon name="userBgFull" :height="25" viewBox="0 0 32 32" class="mr-2 text-gray-600" />
            <span class="font-2xl">
              {{ workflow.audience.totalContacts }}
            </span>
            <span class="total-sent-msg text-gray-700 font-1xl ml-2">{{ $t('campaign.campaignSummary.sms.text.recipients') }}</span>
          </p>
        </CCol>
        <CCol sm="4" class="pl-3 d-flex">
          <p class="d-flex align-self-center mb-0">
            <CIcon name="smsFull" :height="25" viewBox="0 0 32 32" class="mr-3" />
            <span class="font-2xl"> {{ totalSMSCount }} </span>
            <!-- Possível inconsistência na contagem pelo backend -->
            <span class="total-sent-msg text-gray-700 font-1xl ml-2">{{ $t('campaign.campaignSummary.sms.text.sms') }}</span>
          </p>
        </CCol>
      </CRow>

      <CRow class="border-line-bottom">
        <CCol sm="4" class="pt-4">
          <CRow>
            <CCol>
              <div class="font-weight-semi-bold text-gray-600">
                {{ $t('campaign.campaignSummary.sms.text.segments') }}
              </div>
              <CRow class="pt-3">
                <CCol>
                  <CBadge
                    :key="index"
                    class="font-weight-semi-bold px-3 py-2 font-base mx-1 my-1"
                    color="primary"
                    v-for="(segment, index) in workflow.audience.segments"
                  >
                    {{ segment.name }}
                  </CBadge>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCol>

        <CCol sm="4" class="border-line-right pt-4">
          <div class="font-weight-semi-bold text-gray-600">
            {{ $t('campaign.campaignSummary.sms.text.message') }}
          </div>
          <div class="scroll-area-message mt-3">
            {{ workflow.content.content }}
          </div>
        </CCol>

        <CCol sm="4" class="pt-4 pl-5">
          <div class="mb-4">
            <div class="font-weight-semi-bold text-gray-600">
              {{ $t('campaign.campaignSummary.sms.text.schedule') }}
            </div>
            <div class="text-gray-800" style="min-height: 24px" v-if="workflow.time.targetTimeType == 'sendNow'">
              {{ $t('campaign.campaignSummary.sms.text.sendNow') }}
            </div>
            <div class="text-gray-800" style="min-height: 24px" v-else>{{ formatDateMed(workflow.time.scheduleDate) }}</div>
          </div>
          <div class="mb-4" v-if="workflow.time.targetTimeType !== 'sendNow'">
            <div class="font-weight-semi-bold text-gray-600">
              {{ $t('campaign.campaignSummary.sms.text.shippingTime') }}
            </div>
            <div class="text-gray-600"></div>
            <div class="text-gray-800" v-if="workflow.time.scheduleTime">{{ formatHour(workflow.time.scheduleTime) }}</div>
          </div>
          <div class="mb-4" v-if="workflow.time.targetTimeType !== 'sendNow'">
            <div class="font-weight-semi-bold text-gray-600 text-uppercase">
              {{ $t('campaign.creator.blockLibrary.time.label.time-zone') }}
            </div>
            <div class="text-gray-800" v-if="workflow.time.timeZone">{{ workflow.time.timeZone }}</div>
          </div>
          <div class="mb-4" v-if="workflow.time.targetTimeType !== 'sendNow'">
            <div class="font-weight-semi-bold text-gray-600">
              {{ $t('campaign.campaignSummary.sms.text.time') }}
            </div>
            <div class="text-gray-800" style="min-height: 24px">
              <div v-if="!workflow.time.beginTime">{{ $t('campaign.campaignSummary.sms.begin-end-time-not-exist') }}</div>
              {{ workflow.time.beginTime && workflow.time.endTime ? workflow.time.beginTime + ' - ' + workflow.time.endTime : '' }}
            </div>
          </div>
          <div class="mb-4">
            <div class="font-weight-semi-bold text-gray-600">
              {{ $t('campaign.campaignSummary.sms.text.weekends') }}
            </div>
            <div class="text-gray-800" style="min-height: 24px">
              {{
                !workflow.time.isWorkingDays
                  ? $t('campaign.campaignSummary.sms.text.sendWeekends')
                  : $t('campaign.campaignSummary.sms.text.doNotSendWeekends')
              }}
            </div>
          </div>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import { dateFormatStringMed, formatHour } from '../../../../utils/dateUtil'

export default {
  props: {
    workflow: {
      type: Object,
      default: () => ({
        audience: {
          segments: [],
          totalContacts: 0,
        },
        content: {
          content: '',
        },
        time: {
          scheduleDate: null,
          beginTime: null,
          endTime: null,
          isWorkingDays: false,
          targetTimeType: '',
        },
      }),
    },
    totalSMSCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    formatDateMed(date) {
      return dateFormatStringMed(date)
    },
    formatHour(hour) {
      return formatHour(`1988-09-13T${hour}:00`) || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.border-line-bottom {
  border-bottom: 1px solid $gray-300;
}

.border-line-right {
  border-right: 1px solid $gray-300;
}
.page-active {
  color: $gray-700;
  font-weight: 600;
}

.scroll-area-message {
  overflow-y: initial;
  height: 250px;
  word-break: break-word;
}

.individual-engagement {
  font-size: $font-size-md;
  color: $gray-700;
}

.pagination-margin ul {
  margin: 0px !important;
  align-self: center;
}

.background-indicadores {
  background-color: $white;

  icon {
    fill: $gray-300;
  }
}

.total-recipients {
  font-size: $font-size-md2;
  color: $gray-600;
  font-weight: 200;
}

.total-recipients-value {
  font-size: $font-size-md2;
  color: $gray-base;
  font-weight: 200;
}

.scroll-area-message {
  overflow-y: auto;
  height: 250px;
}

.individual-engagement {
  font-size: $font-size-md;
  color: $gray-700;
}
</style>
